import cn from 'classnames';
import PropTypes from 'prop-types';
import uniqueId from 'lodash/uniqueId';
import React, { useRef } from 'react';

import { TextButton } from '@bibliocommons/base-buttons';
import { ArrowDown as IconArrowDown, ArrowUp as IconArrowUp } from '@bibliocommons/base-icons';
import ScreenReaderMessage from '@bibliocommons/base-screen-reader-message';

import './ReOrderButtons.scss';

const ReOrderButtons = ({ canMoveDown, canMoveUp, className, index, items, onChange }) => {
  const instanceId = useRef(uniqueId('ReOrderButtons_'));

  const moveDownButtonKey = `${instanceId}_MoveDownButton`;
  const moveUpButtonKey = `${instanceId}_MoveUpButton`;

  const handleMoveDownClick = () => {
    const swapIndex = index + 1;
    const swapItem = items[swapIndex];

    items[swapIndex] = items[index];
    items[index] = swapItem;

    onChange(items);
  };

  const handleMoveUpClick = () => {
    const swapIndex = index - 1;
    const swapItem = items[swapIndex];

    items[swapIndex] = items[index];
    items[index] = swapItem;

    onChange(items);
  };

  const isMoveUpEnabled = canMoveUp(index, items);
  const isMoveDownEnabled = canMoveDown(index, items);

  return (
    <div className={cn('cp-admin-browse-home-re-order-buttons', className)}>
      <TextButton
        className="arrow-button"
        dataKey={moveUpButtonKey}
        disabled={!isMoveUpEnabled}
        handleClick={handleMoveUpClick}
        type="button"
      >
        <IconArrowUp />
        <ScreenReaderMessage>Move up</ScreenReaderMessage>
      </TextButton>

      <TextButton
        className="arrow-button"
        dataKey={moveDownButtonKey}
        disabled={!isMoveDownEnabled}
        handleClick={handleMoveDownClick}
        type="button"
      >
        <IconArrowDown />
        <ScreenReaderMessage>Move down</ScreenReaderMessage>
      </TextButton>
    </div>
  );
};

ReOrderButtons.defaultProps = {
  canMoveDown: (index, items) => {
    return index < items.length - 1;
  },
  canMoveUp: index => {
    return index > 0;
  }
};

ReOrderButtons.propTypes = {
  canMoveDown: PropTypes.func,
  canMoveUp: PropTypes.func,
  className: PropTypes.string,
  index: PropTypes.number.isRequired,
  items: PropTypes.arrayOf(PropTypes.any).isRequired,
  onChange: PropTypes.func.isRequired
};

export default ReOrderButtons;
